import React from 'react';

import { flagStyles } from '../settings';

const SvgBH = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-504px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBH;
